/**
 * @generated SignedSource<<69e97137ed5215f20004b83bdea0a855>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutReviewTally_transaction$data = {
  readonly sku: {
    readonly " $fragmentSpreads": FragmentRefs<"ImageMultiSkuOverlay_sku">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutMobileSummaryPriceTable_transaction">;
  readonly " $fragmentType": "CheckoutReviewTally_transaction";
};
export type CheckoutReviewTally_transaction$key = {
  readonly " $data"?: CheckoutReviewTally_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutReviewTally_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutReviewTally_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "kind": "LinkedField",
      "name": "sku",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ImageMultiSkuOverlay_sku"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutMobileSummaryPriceTable_transaction"
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "79fdfbd69efd71e4067c6ef7d4519075";

export default node;
